// extracted by mini-css-extract-plugin
export default {"defaultText":"HighlightWords_defaultText__NP5Yk"};